const DEFAULT_SCROLL_SPEED = 500

// Quintic ease-in-out formula
function quinticEaseInOut (time, start, change, duration) {
  time /= duration / 2
  if (time < 1) {
    return change / 2 * Math.pow(time, 5) + start
  }
  time -= 2
  return change / 2 * (Math.pow(time, 5) + 2) + start
}

function scrollIterate (original, target, duration = 100, start = new Date().getTime()) {
  let elapsed = new Date().getTime() - start

  // Use ease function for fanciness
  let next = quinticEaseInOut(elapsed, original, target - original, duration)
  window.scrollTo(0, next)

  // If we're within a pixel or two, snap into exact position
  if (Math.abs(next - target) < 2) {
    window.scrollTo(0, target)
    return
  }

  // If we ran out of time, stop at the right spot anyway
  if (elapsed > duration) {
    window.scrollTo(0, target)
    return
  }

  // Scroll each frame for 60fps butter
  requestAnimationFrame(() => scrollIterate(original, target, duration, start))
}

function safeScroll ({el, left = 0, top = 0, behavior = 'smooth'}) {
  if (typeof el === 'undefined') {
    return false
  }

  const behaviors = ['smooth', 'instant', 'auto']
  if (!behaviors.includes(behavior)) {
    console.warn('Invalid behavior for scroll. https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll')
    return false
  }

  if (typeof left !== 'number' || typeof top !== 'number') {
    console.warn('Invalid top or left for scroll. https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll')
    return false
  }

  el.scroll({ left: left, top: top, behavior: behavior })
  return true
}

export default {
  DEFAULT_SCROLL_SPEED,
  scrollElementsTop: (selector) => {
    const els = document.querySelectorAll(selector)
    if (els.length === 0) {
      console.warn('SmoothScroll selector returned no elements to scroll.', selector)
      return false
    }
    els.forEach(el => safeScroll({ el }))
  },
  goTo: (target, duration = DEFAULT_SCROLL_SPEED) => {
    const html = document.documentElement
    const current = window.pageYOffset || html.scrollTop
    const maxScroll = html.scrollHeight - html.clientHeight
    const realTarget = Math.min(target, maxScroll)
    scrollIterate(current, realTarget, duration)
  },
  getPosition: (el) => {
    const rect = el.getBoundingClientRect()
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }
}
